import { registerComponent } from '@gig/magic-common';
import LiveAgentComponent from './liveagent.vue.js';

var LiveAgent = registerComponent(LiveAgentComponent);

export { LiveAgent };
